import React from 'react';
import { useLanguage } from '../i18n/useLanguage.jsx';

const LanguageSelector = () => {
  const { currentLanguage, changeLanguage } = useLanguage();

  return (
    <div className="language-selector">
      <button
        className={`language-flag ${currentLanguage === 'es' ? 'active' : ''}`}
        onClick={() => changeLanguage('es')}
        title="Español"
        aria-label="Cambiar a Español"
      >
        🇪🇸
      </button>
      <button
        className={`language-flag ${currentLanguage === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        title="English"
        aria-label="Switch to English"
      >
        🇬🇧
      </button>
    </div>
  );
};

export default LanguageSelector;